module.exports = "query GetCoach($slug: String!) {\n  user(storefrontSlug: $slug) {\n    ...CoachFragment\n  }\n}\n"